export default {"src":"/reise/pakkereiser/_next/static/media/tp.a8c9d41b.svg","height":32,"width":32,"blurWidth":0,"blurHeight":0};